import React from "react";

import { localizer } from "../../../Translator";

import { Grid, Container, Button, Typography } from "@material-ui/core";
import { Backdrop, CircularProgress } from "@material-ui/core"
import { IconButton } from "@material-ui/core";
import { styled } from '@material-ui/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Drawer } from "@material-ui/core" 
import Divider from "@material-ui/core/Divider";
import Link from '@material-ui/core/Link';
import Box from "@material-ui/core/Box";
import { Alert, AlertTitle } from '@material-ui/lab';

import { MultiOcrImageViewer } from "../../Utilities/MultiOcrImageViewer";
import { SnackbarCustom } from "../../Utilities/SnackbarCustom";
import Validators from "../../Utilities/Validators.js";

import PostalCodeMask from "../../Utilities/PostalCodeMask.js";

import { AddressSelector } from "../../shipments/sections/address/AddressSelector"
import { ThumbnailImagePage } from "./ThumbnailImagePage";
import { AddressFormatsModal } from "../ocr/AddressFormatsModal";

import OutboxCli from "../../../sdk/OutboxCli";
import AuthCli from "../../../sdk/AuthCli";

const initaladdress = {
  who: "",
  contact: "",
  phone: "",
  identityCard: "",
  countryIso: "",
  locality: "",
  postalCode: "",
  streetType: "",
  streetName: "",
  streetNumber: "",
  streetComplements: "",
  envelopeBox: []
}
      
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
})); 

export class MultiShipmentLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Proposal list containing a set of pages in a draft (or sequence of drafts) to be considered the first page of a shipment in a multi-shipment document
      proposals: [],

      // Proposal list formatted in a Objetct {documentid: string, pagenumber: int, pageindraft: int, initial: bool, pageselected: bool, excluded: bool}
      proposalsformatted: [],

      // Draft ids given by parent component to be sent to API to form the proposals
      documentsid: [],

      // List of ShipmentPages to be used by OCR viewer
      documentpages: [],

      // Index of the page in draft to be displayed
      pagenumber: 1,

      // Error message in case some request fail
      errormessage: null,

      // Success message in case operations were OK
      successmessage: null,

      // Address object needed to fill AddressSelector component
      address: initaladdress,

      // Flag to indicate if current page is initial or not
      iscurrentpageinitial: false,

      // Flag to indicate if current page is exclued or not
      iscurrentpageexcluded: false,

      showEditSection: false,

      left: 45,
      top: 20,
      width: 42,
      height: 7,

      isLoading: false,
      // Load percentage for proposals
      isProcessingProposals: 0,

      opendrawer: false,
      isEditing: false,
      isStart: true, //first time page is loaded

      // Flag to open/close the formats modal
      openFormatsModal: false
    }
  }

  componentDidMount() {
    if (this.props) {
      this.setState({ documentsid: this.props.documentsid },
        () => {
          //When entering, the thumbnails do not load, only the first page.
          this.initize()
          //this.getProposals(true)
        })
    }
  }
  initize = () => {
    let left = this.state.left
    let top = this.state.top
    let width = this.state.width
    let height = this.state.height

    if (this.props.billable && this.props.billable.destinationAddressBox
      && this.validateBoxSelector(this.props.billable.destinationAddressBox)) {
      left = this.props.billable.destinationAddressBox.left
      top = this.props.billable.destinationAddressBox.top
      width = this.props.billable.destinationAddressBox.width
      height = this.props.billable.destinationAddressBox.height
    }
    this.setState({
      left: left,
      top: top,
      width: width,
      height: height,
    }, async () => {
      this.setState({ isLoading: true })
      
      let partialResult = []
      this.props.shipments.forEach(shipment => {
        if (shipment.pages) {
          shipment.pages.forEach(page => {
            partialResult.push({
              pages: page,
              destinationAddress: null
            });
          });
        }
      });

      this.setState({ proposals: partialResult, errormessage: null },
        () => {
          let documentpages = []
          this.state.proposals.forEach(proposal => {
            documentpages.push(proposal.pages)
          });

          this.doFormatProposals()

          let address = this.state.proposals.length > 0 ? this.state.proposals[0].destinationAddress : null
          this.setState({ documentpages: documentpages, pagenumber: 1, address: address, isProcessingProposals: 0 })
        })
      
      this.setState({ isLoading: false })
    })
    



  }
  // Getting and formating proposals given by API based on draft ids list
  getProposals = (takeFromBillable) => {
    let left = this.state.left
    let top = this.state.top
    let width = this.state.width
    let height = this.state.height

    if (takeFromBillable && this.props.billable && this.props.billable.destinationAddressBox
      && this.validateBoxSelector(this.props.billable.destinationAddressBox)) {
      left = this.props.billable.destinationAddressBox.left
      top = this.props.billable.destinationAddressBox.top
      width = this.props.billable.destinationAddressBox.width
      height = this.props.billable.destinationAddressBox.height
    }
   
    this.setState({
      left: left,
      top: top,
      width: width,
      height: height,
    }, async () => {
      this.setState({ isLoading: true, isProcessingProposals: 1, isEditing: false })

      let isProposalsDone = false
      let partialResult = []
      let errormessage = null
      while (!isProposalsDone) {
        let response
        try {
          response = await OutboxCli.DetectShipmentsInDrafts(partialResult, this.state.documentsid, this.state.left, this.state.top, this.state.width, this.state.height, this.props.productSelected ? this.props.productSelected.productCode : null)
        } catch (error) {
          errormessage = error && error.message ? error.message : error.toString()
          break
        }

        if (response !== null && response.toString().startsWith("[ERR")) {
          if (response !== AuthCli.SESSION_EXPIRED_RESPONSE) {
            errormessage = response.substring(response.indexOf(' '))
          }
          break
        }

        // Percentage calculation for linear progress bar.
        let patialResultPages = this.getPagesFormPartialResult(partialResult)
        let percentage = Math.trunc(Number((patialResultPages / this.props.totalpages).toFixed(2)) * 100)
        this.setState({ isProcessingProposals: percentage === 0 ? 1 : percentage })

        // If API response is similiar to proposals already recolected means the process have done.
        if (response !== null && JSON.stringify(response) === JSON.stringify(partialResult)) {
          isProposalsDone = true
          continue
        }

        // Otherwise, proposals are updated.
        partialResult = response
        this.setState({ proposals: partialResult, errormessage: null, isStart: false },
          () => {
            let documentpages = []
            this.state.proposals.forEach(proposal => {
              documentpages.push(proposal.pages)
            });

            this.doFormatProposals()

          })
      }
      
      this.setState({ proposals: partialResult, errormessage: errormessage },
        () => {
          let documentpages = []
          this.state.proposals.forEach(proposal => {
            documentpages.push(proposal.pages)
          });

          this.doFormatProposals()

          let address = this.state.proposals.length > 0 ? this.state.proposals[0].destinationAddress : null
          this.setState({ documentpages: documentpages, pagenumber: 1, address: address, isProcessingProposals: 0 })
        })
      
      this.setState({ isLoading: false })
    })
  }

  /* check if the box is valid to take its coordinates
   * It is defined but some of its coordinates are missing
   * Some of its coordinates are negative
   * The defined area is zero (a line, a point
  */
  validateBoxSelector = (Box) => {
    if (!Box.width || !Box.height || !Box.left || !Box.top) return false
    if (Box.width < 0 || Box.height < 0 || Box.left < 0 || Box.top < 0) return false
    if (Box.width === 0 || Box.height === 0 || (Box.left === Box.top)) return false
    
    return true
  }

  // Formatting the proposals to make easier their management 
  doFormatProposals = () => {
    let proposals = []
    let pagenumber = 0
    let elementIndex = 1
    this.state.proposals.forEach((proposal) => {
      for (let index = proposal.pages.pageFirst; index <= proposal.pages.pageLast; index++) {
        let element = {
          documentid: proposal.pages.draftId,
          pagenumber: ++pagenumber,
          pageindraft: index,
          initial: index === proposal.pages.pageFirst,
          // Initial state, in case the user excludes/includes the initial page
          initialOrig: index === proposal.pages.pageFirst,
          // Setting first page as selected every time proposals are calculated 
          pageselected: elementIndex === 1,
          excluded: false,
          address: index === proposal.pages.pageFirst ? proposal.destinationAddress : null
        }
        elementIndex++
        proposals.push(element)
      }
    });
    this.setState({ proposalsformatted: proposals, iscurrentpageinitial: true })
  }

  // Based on an address returned by ORC function, update the address value in state to be displayed
  doSetAddressByOcrProposal = (addresses) => {
    let address = addresses.length > 0 ? addresses[0] : null
    this.setState({ address: address })
  }

  // Given a page number of a draft, this will be displayed in viewer and marked as selected
  doDisplayPage = (pagenumber) => {
    let excluded = false
    let initial = false
    let address = initaladdress
    let proposalsformatted = this.state.proposalsformatted

    proposalsformatted.forEach((proposal, index) => {
      proposal.pageselected = false
      if (index === (pagenumber - 1)) {
        proposal.pageselected = true

        excluded = proposal.excluded
        initial = proposal.initial
        //if it is the initial page, I get its address to show it in the corresponding component
        if (proposal.initial === true && proposal.address !== null) address = proposal.address
      }
    });

    this.setState({ proposalsformatted: proposalsformatted, iscurrentpageexcluded: excluded, iscurrentpageinitial: initial, pagenumber: pagenumber, address: address, isEditing: false })
  }

  // Toggle between initial / not initial values 
  doToggleInitialPage = () => {
    let excluded = false
    let initial = false
    let proposalsformatted = this.state.proposalsformatted
    proposalsformatted.forEach((proposal, index) => {
      if (proposal.pageselected === true) {
        proposal.initial = !proposal.initial

        excluded = proposal.excluded
        initial = proposal.initial
      }
    });

    this.setState({ proposalsformatted: proposalsformatted, iscurrentpageexcluded: excluded, iscurrentpageinitial: initial })
  }

  // Toggle between inlcude / exclude values and in case of being initial, the page will be marked as not initial
  doToggleExcludePage = () => {
    let excluded = false
    let initial = false
    let proposalsformatted = this.state.proposalsformatted
    proposalsformatted.forEach((proposal, index) => {
      if (!proposal.pageselected) return

      if (proposal.excluded) {
        proposal.excluded = false
        //if I include it again, I should check the initial proposal to put it as initial if it was before
        if (proposal.initialOrig === true) proposal.initial = true
      } else {
        //put the following as initial
        if (proposal.initial && index + 1 < proposalsformatted.length) proposalsformatted[index + 1].initial = true
        proposal.excluded = true
        proposal.initial = false
        
      }

      excluded = proposal.excluded
      initial = proposal.initial
    });
    this.setState({ proposalsformatted: proposalsformatted, iscurrentpageexcluded: excluded, iscurrentpageinitial: initial, isEditing: false })
  }

  doAcceptProposalAddress = (address) => {
    let errors = []
    let errormessage = ""
    let proposalsformatted = this.state.proposalsformatted.map((proposal) => {
      if (!proposal.pageselected || !proposal.initial) return proposal

      proposal.address = address
      errors = errors.concat(this.validateAddress(address, "RECIPIENT"))
      return proposal
    })

    if (errors.length !== 0) {
      errors.forEach(error => {
        errormessage += error + "\n"
      })
      
      this.setState({ errormessage: errormessage })
    } else {
      this.setState({ proposalsformatted: proposalsformatted, successmessage: localizer.MultishipmentSuccessApplyMessage, isEditing: false }, () => { this.doToggleEditAddress() })
    }
  }

  doAcceptAllProposalAddress = (address) => {
    let proposalsformatted = this.state.proposalsformatted.map((proposal) => {
      if (!proposal.initial) return proposal

      proposal.address = address
      return proposal
    })
    this.setState({ proposalsformatted: proposalsformatted, isEditing: false })
  }

  doDiscardProposalAddress = () => {
    let proposalsformatted = this.state.proposalsformatted.map((proposal) => {
      if (!proposal.pageselected || !proposal.initial) return proposal

      let proposalupdated = { ...proposal, address: null }
      return proposalupdated
    })
    this.setState({ proposalsformatted: proposalsformatted, address: initaladdress, isEditing: false })
  }

  doEndProposals = () => {
    let errors = []
    let initialshipment = this.props.shipments && this.props.shipments.length > 0 ? this.props.shipments[0] : null
    if (!initialshipment) return

    initialshipment.features.reference = ""

    // Sequence of pages as defined by the user.
    var finalPages = this.state.proposalsformatted

    let addresserror = false
    finalPages.forEach(fp => {
      if (fp.initial && !fp.address) {
        addresserror = true
      } else if (fp.initial && fp.address) {
        errors = errors.concat(this.validateAddress(fp.address, "RECIPIENT"))
      }
    })


    if (addresserror || errors.length !== 0) {
      this.setState({ errormessage: localizer.MultishipmentAddressNotFound })
      return
    }

    //If there is no error, it means that the proposed addresses are valid.
    let isValidedProposalAddress = true

    // To contain the final result. The list of shipments from the finally defined pages.
    var shipments = []
    // Temporary structure to be built as we go through pages. Represents the shipment being built.
    var shipment = null

    // Go through all pages as the user defined them.
    for (let p = 0; p < finalPages.length; p++) {
      // Skip excluded pages.
      if (finalPages[p].excluded) {
        continue
      }
      // Reached a new shipment. Complete previous.

      if (finalPages[p].initial && shipment) {
        shipments.push(shipment)
        shipment = null
      }
      // Starting a new shipment.
      if (!shipment) {
        shipment = { ...initialshipment }
        shipment.pages = [{
          draftId: finalPages[p].documentid,
          pageFirst: finalPages[p].pageindraft,
          pageLast: finalPages[p].pageindraft, // Initially this shipment contains one page. To be modified in next iterations of the loop.
        }]
        shipment.destinationAddress = finalPages[p].address

        // Continuing a shipment (with incomplete pages).
      } else {
        // Adding next page in the same draft (because it is the same draft as previous and page number is consecutive).

        var lastPagesEntry = shipment.pages[shipment.pages.length - 1]
        if (lastPagesEntry.draftId === finalPages[p].documentid && lastPagesEntry.pageLast + 1 === finalPages[p].pageindraft) {
          let pagesModified = shipment.pages
          pagesModified[shipment.pages.length - 1].pageLast = finalPages[p].pageindraft // Last page of the structure Shipment.ShipmentPages is changed (a page has been added).
          shipment = { ...shipment, pages: pagesModified }
        }
        // Adding next page in a different draft (or same draft but not consecutive page from previous).
        else {
          let pagesAdded = shipment.pages

          pagesAdded.push({
            draftId: finalPages[p].documentid,
            pageFirst: finalPages[p].pageindraft,
            pageLast: finalPages[p].pageindraft,
          })
          shipment = {
            ...shipment,
            pages: pagesAdded,
          }
        }
      }
    }
    // Completing the last shipment.

    if (shipment) shipments.push(shipment)
    // At this point "shipments" is an array of objects fullfilling Outbox API structure "IOutboxApi.Shipment".

    this.props.handleMultishipment(shipments, isValidedProposalAddress)
  }

  handleAddress = (address, owner) => {
    if (owner !== "RECIPIENT") return
    
    this.setState({ address: address, isEditing: true })
  }

  handleDrawerOpen = () => {
    this.setState({ opendrawer: true })
  }
  handleDrawerClose = () => {
    this.setState({ opendrawer: false })
  }

  handleonClose = () => {
    this.setState({ errormessage: null, successmessage: null })
  }

  doRecalculateProposals = (left, top, width, height) => {
    this.setState({
      left: left,
      top: top,
      width: width,
      height: height,
    }, () => { this.getProposals(false) })
  }

  doToggleEditAddress = () => {
    this.setState({ showEditSection: !this.state.showEditSection })
  }

  // Returns the number of total pages from proposals requested
  getPagesFormPartialResult = (partialResult) => {
    let totalpages = 0
    partialResult && partialResult.forEach(p => {
      if (!p.pages) return
      
      totalpages = totalpages + (p.pages.pageLast - p.pages.pageFirst + 1)
    })
    return totalpages
  }

  validateAddress = (address, target) => {
    let errors = []
    if (!address) {
      errors.push(localizer.AddressErrorEmpty)
      return errors
    }
    
    if (!address.who || address.who === "") errors.push(localizer.AddressErrorWho)
    if (target === "SENDER") {
      let identification = Validators.documentIdentification(address.identityCard)
      if (!identification || (!identification.isValid)) errors.push(localizer.AddressErrorIdentification)
    }
    if (target === "RECIPIENT" && address.identityCard && address.identityCard !== "") {
      let identification = Validators.documentIdentification(address.identityCard)
      if (!identification || (!identification.isValid)) errors.push(localizer.AddressErrorIdentification)
    }
    if (!address.countryIso || address.countryIso === "") errors.push(localizer.AddressErrorCountryIso)
    if (!address.locality || address.locality === "") errors.push(localizer.AddressErrorLocality)
    if (!address.postalCode || address.postalCode === "") errors.push(localizer.AddressErrorPostalCode)
    if (!address.streetName || address.streetName === "") errors.push(localizer.AddressErrorStreetName)
    // Note: disabled this restriction: if (!address.streetNumber || address.streetNumber === "") errors.push(localizer.AddressErrorStreetNumber)
    
    if (address.postalCode && address.postalCode !== "" && address.countryIso && address.countryIso !== "" && (address.countryIso == "ES" || address.countryIso == "PT")) {
      let match = PostalCodeMask.checkPostalCodeMask(address.countryIso, address.postalCode)
      if (match === false) errors.push(localizer.AddressErrorPostalCodeMask)
    }
    if (target === "RECIPIENT") {
      if (this.props.productSelected && this.props.productSelected.scope === "INTERNATIONAL" &&
        (address.countryIso.toUpperCase() === "ES" || address.countryIso.toUpperCase() === "PT")) errors.push(localizer.AddressErrorCountryInternational)
      if (this.props.productSelected && this.props.productSelected.scope === "DOMESTIC" &&
        (address.countryIso.toUpperCase() !== "ES" && address.countryIso.toUpperCase() !== "PT")) errors.push(localizer.AddressErrorCountryDomestic)
    }
    
    if (address.who.length > 100) errors.push(localizer.AddressErrorLengthWho)
    if (address.streetName.length > 100) errors.push(localizer.AddressErrorLengthStreetName)
    
    let messagetarget = target === "RECIPIENT" ? localizer.AddressErrorDestination : localizer.AddressErrorSender
    if (errors.length !== 0) errors.unshift(messagetarget + localizer.AddressError)
      
    return errors
  }

  onCloseFormatsModal = () => { this.setState({ openFormatsModal: false }) }

  render() {
    return (
      <React.Fragment>

        <Container>
          {/* Information about how to use multi shipment section */}
          <Alert severity="info" icon={false}>
            <Typography className="typography-generic p-0">
              <IconButton className="button-generic icon-button p-0" aria-label="Open Information" onClick={this.handleDrawerOpen} edge="start">
                <ChevronLeftIcon fontSize="inherit" />
              </IconButton>
              {localizer.Get}
              <Link className="typography-generic" onClick={this.handleDrawerOpen}> <strong>{localizer.Information}</strong></Link>
              {localizer.AboutUse}
            </Typography>
          </Alert>

          <Grid container item md={12}>
            <AddressSelector
              address={this.state.address}
              handleAddress={this.handleAddress}
              ownerAddress="RECIPIENT"
              draftsSelected={this.state.documentsid}
              multishipment={this.state.iscurrentpageinitial ? "INITIAL" : "NOT INITIAL"}
              alertSenderEmpty=""
              doAcceptProposalAddress={this.doAcceptProposalAddress}
              doDiscardProposalAddress={this.doDiscardProposalAddress}
              isEditing={this.state.isEditing}
              isValidedProposalAddress={this.state.isValidedProposalAddress}
              productSelected={this.props.productSelected}
            >
            </AddressSelector>
          </Grid>

          <Grid container item md={12} >
            <Grid item md={9}>
              {/* Information and warnings about completing multi-shipment process */}
              <Alert severity="info" className="mt-5">
                <Typography className="typography-generic p-0">
                  {localizer.MultiShipmentTitleActions}
                  <a className="cursor-pointer font-weight-bold" onClick={() => { this.setState({ openFormatsModal: true }) }}>{localizer.ClickHere}</a>
                </Typography>
              </Alert>
              <Alert severity="warning" className="mt-5">
                <AlertTitle>
                  <Typography className="typography-generic font-weight-bold p-0">{localizer.Warning}:</Typography>
                </AlertTitle>
                <Typography className="typography-generic p-0">
                  {localizer.formatString(localizer.MultiShipmentWarning, this.state.proposalsformatted && this.state.proposalsformatted.filter(function (p) { return p.initial === true }).length)}</Typography>
              </Alert>
            </Grid>
            <Grid container item md={3} justify="flex-end">
              <Button className="button-generic dialog-primary60 mt-10" variant="contained" name="end" disabled={this.state.isEditing} onClick={this.doEndProposals}>{localizer.Next}<br />{localizer.MultishipmentEnd}</Button>
              <Button className="button-generic dialog-primary60 mt-10" variant="contained" name="end" disabled={this.state.isEditing} onClick={() => { this.getProposals(true) }}>{localizer.MultiDetectAddress}<br />{localizer.MultiDetectAddressInfo}</Button>
            </Grid>
          </Grid>

          <Grid container item md={12} className="mt-10 pt-10" style={{ border: "solid 2px gray" }}>
            <Grid container item md={3} direction="row" style={{ display: "block" }}>

              <Grid container item md={12} spacing={2} direction="row" className="pl-10 scroll-custom" style={{ maxHeight: "840px" }}>
                {/* Number of Shipments information */}
                <Grid container item md={12}>
                  <Alert severity="info" icon={false} style={{ width: "100%" }}>
                    <Typography className="typography-generic  p-0">
                      <strong>{localizer.NumberOfShipments + ": "}</strong>
                      &nbsp;
                      {this.state.proposalsformatted && this.state.proposalsformatted.filter(function (p) { return p.initial === true }).length}
                    </Typography>
                  </Alert>
                </Grid>
                {/* Thumbnail image list */}
                {!this.state.isStart && this.state.proposalsformatted.map(proposal => {
                  return (
                    <Grid key={proposal.documentid + "-" + proposal.pageindraft} container item md={6} className={proposal.pageselected ? "page-selected" : ""}>
                      <ThumbnailImagePage documentid={proposal.documentid}
                        pagenumber={proposal.pagenumber}
                        pageindraft={proposal.pageindraft}
                        pageselected={proposal.pageselected}
                        initial={proposal.initial}
                        address={proposal.address}
                        excluded={proposal.excluded}
                          
                        proposal={proposal}
                        doDisplayPage={this.doDisplayPage}
                        doToggleInitialPage={this.doToggleInitialPage}
                        doToggleExcludePage={this.doToggleExcludePage}
                      >
                      </ThumbnailImagePage>
                    </Grid>
                  )
                })}
              </Grid>
            </Grid>
            
            {/* Current page preview */}
            <Grid container item md={9}>
              {this.state.documentpages && this.state.documentpages.length > 0 &&
                <MultiOcrImageViewer
                  documentpages={this.state.documentpages}
                  pagenumber={this.state.pagenumber}
                  coordinatedLeft={this.state.left}
                  coordinatedTop={this.state.top}
                  coordinatedWidth={this.state.width}
                  coordinatedHeight={this.state.height}
                  viewerWidth={750}
                  viewerHeight={900}
                  doSetAddressByOcrProposal={this.doSetAddressByOcrProposal}
                  doRecalculateProposals={this.doRecalculateProposals}
                  productSelected={this.props.productSelected}>
                </MultiOcrImageViewer>
              }
            </Grid>
          </Grid>
        </Container>
        
        {/* Information about how to use multi shipment section */}
        <Drawer className="drawer-ms-custom"
          variant="persistent"
          anchor="left"
          open={this.state.opendrawer}
          PaperProps={{
            style: {
              position: "fixed",
            }
          }}
        >
          <DrawerHeader>
            <IconButton onClick={this.handleDrawerClose} float="right" edge="end" alignitems="flex-end" className="font-size-30">
              {this.state.opendrawer ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <Grid container style={{ display: "flex" }} justifycontent='flex-end' justify="flex-end">
            <Grid item md={12}>
              {/* <Typography className="typography-generic">{localizer.OcrMultiShipment}</Typography> */}
              <Typography className="typography-generic medium bigweight secondary"><i className="fa-solid fa-clock secondary"></i> {localizer.OcrMultiShipment}
                <hr className="hr-custom"></hr>
              </Typography>
            </Grid>
            <Grid item md={12}>
              <ol>
                <li className="typography-generic">{localizer.BoxSelectorStepOneMulti}</li>
                <li className="typography-generic">{localizer.BoxSelectorStepTwo}
                  <ul>
                    <li className="typography-generic">{localizer.BoxSelectorStepTwoNoteMulti}</li>
                    <li className="typography-generic">{localizer.BoxSelectorStepTwoNoteTwoMulti}</li>
                    <li className="typography-generic">{localizer.BoxSelectorStepTwoNoteThreeMulti}</li>
                  </ul>
                </li>
                <li className="typography-generic">{localizer.BoxSelectorStepThreeMulti}
                  <ul>
                    <li className="typography-generic">{localizer.BoxSelectorStepThreeOneMulti}</li>
                    <li className="typography-generic">{localizer.BoxSelectorStepThreeTwoMulti}</li>
                    <li className="typography-generic">{localizer.BoxSelectorStepThreeThreeMulti}</li>
                    <li className="typography-generic">{localizer.BoxSelectorStepThreeFourMulti}</li>
                  </ul>
                </li>
                <li className="typography-generic">{localizer.BoxSelectorStepFourMulti}</li>
              </ol>
            </Grid>
          </Grid>
        </Drawer>

        {/* Address formats modal */}
        <AddressFormatsModal openModal={this.state.openFormatsModal} handleCloseModal={this.onCloseFormatsModal} />

        {/* Download draft error. */}
        <SnackbarCustom message={this.state.errormessage} severity="error" handleonClose={this.handleonClose} />
        <SnackbarCustom message={this.state.successmessage} severity="success" handleonClose={this.handleonClose} />
        
        {/* Waiting for service response. */}
        <Backdrop open={this.state.isProcessingProposals > 0 && this.state.isProcessingProposals < 100} style={{ zIndex: 99 }}>
          <CircularProgress variant="determinate" value={this.state.isProcessingProposals} className="circular-progress-custom" />
          <Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
            <Typography className="typography-generic color-primary">{this.state.isProcessingProposals + "%"}</Typography>
          </Box>
        </Backdrop>

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/multishipment/MultiShipmentLayout.js